import { axiosConfig } from './axios-config.js'

const BASE = '/api/monthly-reports/residents'

// axios-config 攔截器把錯誤回應也 resolve，需自行判斷成敗
export const isSuccessResponse = response =>
  Boolean(response && response.status <= 201 && response.data && response.data.status === 'success')

export const responseErrorMessage = (response, fallback) =>
  (response && response.data && (response.data.errMsg || response.data.message)) || fallback

// 住民月報
export const monthlyReport = {
  // 不帶 month 時後端回上個月的待填清單
  getPendingResidents: token =>
    axiosConfig.get('/api/monthly-reports/pending', token),

  searchResidents: (keyword, token) => {
    const config = Object.assign({}, token)
    config.params = { keyword }
    return axiosConfig.get(BASE, config)
  },

  getResidentMonths: (residentId, token) =>
    axiosConfig.get(`${BASE}/${residentId}`, token),

  getMonthDetail: (residentId, month, token) =>
    axiosConfig.get(`${BASE}/${residentId}/${month}`, token),

  getTimeline: (residentId, month, token) =>
    axiosConfig.get(`${BASE}/${residentId}/${month}/timeline`, token),

  updateMode: (residentId, mode, token) =>
    axiosConfig.put(`${BASE}/${residentId}/mode`, { mode }, token),

  saveComment: (residentId, month, mode, data, token) =>
    axiosConfig.put(`${BASE}/${residentId}/${month}/comments/${mode}`, data, token),

  publishComment: (residentId, month, mode, token) =>
    axiosConfig.post(`${BASE}/${residentId}/${month}/comments/${mode}/publish`, null, token),

  unpublishComment: (residentId, month, mode, token) =>
    axiosConfig.delete(`${BASE}/${residentId}/${month}/comments/${mode}/publish`, token)
}
